export function escapeHtml(s: unknown): string {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function highlightQuery(q: string): string {
  return escapeHtml(q).replace(
    /\b(AND|OR|NOT)\b/g,
    '<span class="text-primary-container">$1</span>',
  );
}

const JOB_KEY = "orion1_last_job_id";

export function getStoredJobId(): string {
  try {
    return sessionStorage.getItem(JOB_KEY) || "";
  } catch {
    return "";
  }
}

/** Turn API / OpenRouter errors into a short user-facing message. */
export function formatApiError(e: unknown): string {
  const raw =
    e instanceof Error ? e.message : typeof e === "string" ? e : "Request failed";
  if (raw.includes("402") || raw.toLowerCase().includes("credits")) {
    return (
      "OpenRouter credits insufficient for this model. Try Sync models → pick a cheaper " +
      "economy model, or add credits at openrouter.ai."
    );
  }
  if (raw.includes("max_tokens") || raw.includes("65536")) {
    return (
      "OpenRouter token limit exceeded. Retry after selecting a smaller model, or set " +
      "OPENROUTER_MAX_TOKENS lower in .env.local."
    );
  }
  const m = raw.match(/'message':\s*"([^"]+)"/);
  if (m?.[1]) return m[1];
  if (raw.length > 280) return `${raw.slice(0, 280)}…`;
  return raw;
}

export function setStoredJobId(jobId: string): void {
  try {
    if (jobId) sessionStorage.setItem(JOB_KEY, jobId);
    else sessionStorage.removeItem(JOB_KEY);
  } catch {
    /* ignore */
  }
}
